import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Dialog } from '@material-ui/core';
import AddMore from '../normal/AddMore';
import { globalData, ADD, EDIT, VIEW, CLIENT, SPOUSE, NORMAL, CHILD } from '../../../../common/common';
import EditPanel from './Panel/EditPanel';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    overflowY: 'scroll',
    '& .textWapper': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textWapperF': {
        width: '100%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
})

class Input7 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: [
                // {
                //     ".CHO.N.": "",
                //     ".CHO.R.C.": "",
                //     ".CHO.AddrNPho": {
                //         "phone": "",
                //         "unit": "",
                //         "street": "",
                //         "city": "",
                //         "country": "",
                //         "state": "",
                //         "zipcode": "",
                //     },
                //     ".CHO.Em.": "",
                // }
            ],
            openPanel: false,
            panelType: "",
            panelId: "",
            isAdd: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.handleOpenPanel = this.handleOpenPanel.bind(this);
        this.handleClosePanel = this.handleClosePanel.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.addInfoData = this.addInfoData.bind(this);
        this.addPanel = this.addPanel.bind(this);
    }
    render() {
        const { dragData, state, data, dataINFO } = this.props;
        const { openPanel, panelType, dataInfo, panelId, isAdd } = this.state;
        return (
            <Root ref={(el) => { this.messagesEnd = el; }}>
                <AddMore
                    name="Living Will"
                    haveEmail={true}
                    state={state}
                    spouseInfo={globalData.spouseInfo}
                    data={data}
                    dragData={dragData}
                    adrsPhoKey=".CHO.AddrNPho"
                    rcKey=".CHO.R.C."
                    lock={false}
                    lockNum={0}
                    handleChange={this.handleChange}
                    handleOpenPanel={this.handleOpenPanel}
                    addPanel={this.addPanel}
                    ref={(child) => { this.addMore = child }}
                />
                <EditPanel
                    open={openPanel}
                    isAdd={isAdd}
                    dataINFO={dataINFO}
                    data={dataInfo}
                    panelId={panelId}
                    panelType={panelType}
                    onClose={this.handleClosePanel}
                    updateInfoData={this.updateInfoData}
                    addInfoData={this.addInfoData}
                ></EditPanel>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        const {
            data,
        } = this.props;
        if (prevProps.data !== data) {
            if (data) {
                this.setState({
                    dataInfo: data
                });
            }
        }
    }
    initData() {
        const { data } = this.props;
        if (!data) return;
        this.setState(() => ({
            dataInfo: data
        }))
    }
    handleChange(dataInfo) {
        this.setState(()=>({
            dataInfo
        }))
        this.props.setToAllData("LW", dataInfo);
    }
    handleOpenPanel(data) {
        if (data.type === 0) return;
        this.setState({
            panelId: data.id,
            panelType: data.type,
            isAdd: false,
            openPanel: true
        })
    }
    addPanel() {
        this.setState({
            panelType: NORMAL,
            isAdd: true,
            openPanel: true
        })
    }
    handleClosePanel() {
        this.setState({
            openPanel: false
        })
    }
    
    updateInfoData(panelData) {
        const type = panelData.type;
        if (type === CHILD || type === NORMAL) {
            this.props.uploadChildNormalToAllData(panelData);
        } else {
            this.setDataInfo(panelData, (dataINFO) => {
                this.props.setToAllData("INFO", dataINFO, () => {
                    this.props.updateInfoToAllData();
                });
            });
        }
    }
    addInfoData(panelData) {
        const { dataInfo } = this.state;
        dataInfo.push(panelData);
        this.setState({
            dataInfo
        }, () => {
            this.props.setToAllData("LW", dataInfo);
        })
    }
    setDataInfo(panelData, callback = null) {
        const { dataINFO } = this.props;
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataINFO) {
                    if (Object.hasOwnProperty.call(dataINFO, key2)) {
                        if (key === key2) {
                            dataINFO[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        if (callback) callback(dataINFO);
    }
    doNext() {
        const { dataInfo } = this.state;
        let canNext = true;
        for (const obj of dataInfo) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (key === ".CHO.AddrNPho") {
                        canNext = this.verifyAddrValue(obj[key]);
                        if (canNext) {
                            continue;
                        }
                    } else if (key === ".CHO.Em." || key === "P.W.Pho" || key === "S.W.Pho") {
                        continue;
                    }
                    if (obj[key] === "" || canNext === false) {
                        if (key === "phone") continue;
                        return false;
                    }
                }
            }
        }
        if (dataInfo.length < 2) {
            globalData.toastMsg = "At least 2 people are required";
            return false;
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    getData() {
        return this.state.dataInfo;
    }
    getContentRectData() {
        if (this.props.dragData) {
            return this.addMore.getContentRectData();
        }
        return null;
    }
    handleCollision() {
        this.addMore.handleCollision();
    }
    handleLeave() {
        this.addMore.handleLeave();
    }
    handleUp() {
        this.addMore.handleUp();
    }
    handleDown() {
        this.scrollToBottom();
    }
    scrollToBottom() {
        if (this.messagesEnd) {
            const scrollHeight = this.messagesEnd.scrollHeight;//里面div的实际高度  2000px
            const height = this.messagesEnd.clientHeight;  //网页可见高度  200px
            const maxScrollTop = scrollHeight - height;
            this.messagesEnd.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
            //如果实际高度大于可见高度，说明是有滚动条的，则直接把网页被卷去的高度设置为两个div的高度差，实际效果就是滚动到底部了。
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default Input7;